import { render, staticRenderFns } from "./AuthenticationPopup.vue?vue&type=template&id=fd4fcb42&scoped=true&"
import script from "./AuthenticationPopup.vue?vue&type=script&lang=js&"
export * from "./AuthenticationPopup.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationPopup.vue?vue&type=style&index=0&id=fd4fcb42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4fcb42",
  null
  
)

export default component.exports